<template>
  <div class="hello">

   <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      background="#ababab"
      img-width="1024"
      img-height="480"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Text slides with image -->
        <b-carousel-slide class="video-slide"
          img-src="../assets/img/slide-1.jpg"
          id="slide1"
        >
          <div class="slide-inner">
            <div class="embed-responsive">
            <youtube video-id="U7b6P86bNlI" :player-vars="playerVars" ref="youtube">
              <!-- <b-embed
                type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/embed/U7b6P86bNlI?&autoplay=1&&loop=1&playlist=U7b6P86bNlI"
                allowfullscreen
                allow="autoplay"
                autoplay="true"
              ></b-embed> -->
            </youtube>
            </div>
          </div>
        </b-carousel-slide>

      <!-- <b-carousel-slide
        img-src="../assets/img/slide-1.jpg"
      ></b-carousel-slide> -->
    </b-carousel>

    <b-modal id="video-1" centered hide-footer busy="true" modalClass="ww-video-modal">
      <template v-slot:default="">
        <b-container class="">
          <b-row>
            <b-col>
              <b-embed
                type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/embed/U7b6P86bNlI?&autoplay=1&&loop=1&playlist=U7b6P86bNlI"
                allowfullscreen
                allow="autoplay"
                autoplay="true"
              ></b-embed>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <b-container class="ww-section">
      <b-row>
        <b-col>
          <h1 id="installation">Designed for Ease Of Installation</h1>

          <p>Wetwall panels come in easy-to-install kits and a wide array of individual panel sizes, allowing you to transform any wet space. This innovative product can beautifully redefine a shower, tub surround, wall cladding and more while offering industry-leading performance. <br class="d-none d-md-block">Wherever design meets water, think Wetwall.</p>

<!--           <div class="ww-button-block">
            <a href="../pdf/Wilsonart-Wetwall-Installation-Specifications.pdf" target="_blank">Specifications</a>
          </div> -->

        </b-col>
      </b-row>
    </b-container>

    <b-container class="ww-section">
      <b-row>
        <b-col class="col-6 col-md-2 wetwall-item" v-for="item in kits" v-bind:key="item.id">
            <b-img :src="item.thumb" fluid />
            <h4 style="letter-spacing: 0;">{{ item.name }}</h4>
        </b-col>
      </b-row>
    </b-container>

    <hr />

    <b-container class="ww-section">
      <b-row>
        <b-col>
          <h1 id="installation">Samples</h1>
          <p class="subhead">Click below to request samples of Wetwall designs.</p>

          <div class="ww-button-block">
            <a href="mailto:customerservice@wetwall.com?subject:Sample Request" target="_blank">request samples</a>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <hr />

    <b-container class="ww-section">
      <b-row>
        <b-col>
          <h1 id="installation">Contact a Dealer</h1>
          <!-- <p class="subhead">To contact a dealer with your Wetwall questions, please <a href="mailto:Philip.Harms@wilsonart.com">click here</a>.</p> -->

          <p>Email: <a href="mailto:customerservice@wetwall.com">customerservice@wetwall.com</a></p>
          <p>Phone number: <a href="tel:1866-WETWALL">866-WETWALL</a></p>

<!--           <b-container class="ww-section contact-form">
            <b-row>
              <b-col sm="12" lg="6">
                <input id="name" type="text" class="form-control">
                <label for="name">Name</label>
              </b-col>

              <b-col sm="12" lg="6">
                <input id="email" type="text" class="form-control">
                <label for="email">Email</label>
              </b-col>
            </b-row>

            <b-row>
              <b-col sm="12" lg="6">
                <input id="phone" type="text" class="form-control">
                <label for="phone">Phone Number</label>
              </b-col>

              <b-col sm="12" lg="6">
                <input id="address" type="text" class="form-control">
                <label for="address">Address</label>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <div class="ww-button-block" style="margin-top: 20px;">
                  <a>Submit</a>
                </div>
              </b-col>
            </b-row>
          </b-container> -->


        </b-col>
      </b-row>
    </b-container>

    <hr />

    <b-container class="ww-section">
      <b-row>
        <b-col>

          <h1 id="faqs">FAQs</h1>

          <div class="container">
            <div class="row">
              <div class="col col-12" v-for="(faq, index) in faqs" v-bind:key="index">
                <p><strong>Q: {{ faq.question }}</strong><br />
                A: {{ faq.answer }}</p>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modal-sku" centered hide-footer title=""  busy="true">
      <template v-slot:default="">
        <b-container class="">
          <b-row>
            <b-col sm="0" md="6">
              <b-carousel
                class="d-none d-md-block"
                id="carousel-modal"
                v-model="slide"
                :interval="4000"
                indicators
                background="#ababab"
                img-width="1024"
                img-height="480"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
              >
                <!-- Text slides with image -->
                <b-carousel-slide v-for="image in currentItem.images"
                  :img-src="image"
                  v-bind:key="image"
                ></b-carousel-slide>

              </b-carousel>
            </b-col>

            <b-col sm="12" md="6">
                  <h1 class="name">shower/tub surround</h1>
                  <h2 class="sku">{{ currentItem.sku }}</h2>

                  <b-carousel
                    style="margin-bottom: 20px;"
                    class="d-block d-md-none"
                    id="carousel-modal"
                    v-model="slide"
                    :interval="4000"
                    indicators="false"
                    background="#ababab"
                    img-width="1024"
                    img-height="480"
                    @sliding-start="onSlideStart"
                    @sliding-end="onSlideEnd"
                  >
                    <!-- Text slides with image -->
                    <b-carousel-slide v-for="image in currentItem.images"
                      :img-src="image"
                      v-bind:key="image"
                    ></b-carousel-slide>

                  </b-carousel>

                  <h4 class="exclusively" v-if="currentItem.group == 'lowes'">Exclusively available at <img src="../assets/img/logos/logo-lowes.jpg" class="play" /></h4>
                  <h4 class="exclusively" v-else-if="currentItem.group == 'menards'">Exclusively available at <img src="../assets/img/logos/logo-menards.jpg" class="play" /></h4>
                  <p>{{ currentItem.copy }}</p>
                  <!-- <b-button @click="hide()">Hide Modal</b-button> -->

                  <!--

                  <div v-if="currentItem.group == 'lowes'" class="">
                    <div class="ww-button-block" style="margin-top: 20px;">
                      <a href="https://www.lowes.com/store/" target="_blank">Find in Store</a>
                    </div>
                  </div>

                  <div v-else-if="currentItem.group == 'menards'" class="">
                    <div class="ww-button-block" style="margin-top: 20px;">
                      <a href="https://www.menards.com/main/storeLocator.html" target="_blank">Find in Store</a>
                    </div>
                  </div>

                  <div v-else>
                    <div style="display:none;">
                      <GmapMap
                        ref="mapRef"
                        :center="{lat:sorted_markers[0].lat, lng:sorted_markers[0].lng}"
                        :zoom="9"
                        map-type-id="terrain"
                        style="width:100%;  height: 400px;"
                        :options="mapStyles"
                      >
                        <GmapInfoWindow :oooptions="{maxWidth: 400}"
                        :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">


                        </GmapInfoWindow>

                        <GmapMarker
                          :key="index"
                          v-for="(m, index) in sorted_markers"
                          :position="m.position"
                          :clickable="true"
                          :draggable="true"
                          ccclick="center=m.position"
                          @click="toggleInfoWindow(m,i)"
                        />
                      </GmapMap>
                    </div>

                    <b-container>
                      <b-row>
                        <b-col>
                          <b-form-input v-model="zipCode" id="zipcode" placeholder="Zip Code"></b-form-input>

                          <div class="ww-button-block" style="margin-top: 20px;">
                            <a v-on:click="zipCodeLookup">Find in Store</a>
                          </div>

                          <b-row>
                            <b-col md="6" v-for="marker in sorted_markers" :key="marker.id" class="store-list">
                            <a :href="'https://www.google.com/maps/search/?api=1&query=' + encodeURI(marker.address1) + '+' + encodeURI(marker.city) + '+' + encodeURI(marker.state) + '+' + encodeURI(marker.zip) + '+'" target="_blank">
                            <span class="name">{{ marker.name }}</span><br />
                            {{ marker.address1 }}<br />
                            {{ marker.city }}, {{marker.state }} {{ marker.zip }}</a><br /><br />
                            </b-col>

                            <div style="text-align: center; width: 100%;">
                            <a class="view-more" v-on:click="shortList = false" v-if="shortList">
                              view more locations<br />
                              <i class="arrow down"></i>
                            </a>
                            </div>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-container>
                  </div>
                -->
            </b-col>
          </b-row>
        </b-container>

        <b-container class="ww-section" style="margin-top: 40px;">
          <b-row>
            <b-col md="6" style="text-align: center;">
              <b-img src="../assets/img/profiles-1.jpg" style="max-width: 350px;" fluid></b-img>
            </b-col>
            <b-col md="6" style="text-align: center;">
              <b-img src="../assets/img/profiles-2.jpg" style="max-width: 350px;" fluid></b-img>
            </b-col>
          </b-row>
        </b-container>

        <b-container class="ww-section">
          <b-row>
            <b-col style="text-align: center;">
              <p class="specs"><strong>Panel Thickness:</strong> 0.43" (11mm) </p>
              <p class="specs"><strong>Weight:</strong> 1.65 lb/sq.ft.</p>
              <p class="specs"><strong>Available Panel Widths:</strong> 30" (762mm); 32” (812mm)</p>
              <p class="specs"><strong>Available Panel Heights:</strong> 72" (1829mm); 96" (2438mm)</p>
              <p class="specs"><strong>Installation:</strong> Panel Adhesive and Color Matched Sealant</p>

              <div class="ww-button-block" style="margin-top: 30px;">
                <a href="#" target="_blank">Technical specs pdf</a>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

  </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'


export default {
  name: 'Resources',
  props: {
    msg: String
  },

  data: function () {
    return {
      playerVars: {
        loop: 1,
        playlist: 'U7b6P86bNlI',
      },
      currentItemNumber: 0,
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      zipCode: '',
      shortList: true,

      infoOptions: {
        content: '',
        //optional: offset infowindow so it visually sits nicely on top of our marker
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      faqs: [
              {
                question: 'What is Wetwall? ',
                answer: 'Wetwall is an innovative wall panel system for wet applications, such as tub/shower walls, wainscoting, wall cladding, backsplashes, tub skirts, and more. Unlike tile and grout, Wetwall doesn’t need to be sealed and is easy to clean and is offered in a number of beautiful designs.',
              },
              {
                question: 'Why Wetwall? ',
                answer: 'Wetwall makes it easier than ever to provide consumer driven designs in a waterproof solution that is functionally beautiful, quick and easy to install and offers the look of luxury at an economical price. EASY installation. EASIER maintenance.',
              },
              {
                question: 'What material is Wetwall panels made of?',
                answer: 'Patented wall panel system consisting of two panels made of High Pressure Decorative Laminate bonded to a water­proof core (Wood Plastic Composite; WPC). Panels can feature a flat edge, tongue/groove edge, and a decorative bullnose edge.',
              },
              {
                question: 'What tub/shower configurations can Wetwall be used for?',
                answer: 'Single wall, corner, and alcove baths/showers. Innovative tongue/groove and postformed panels can extend beyond bath/shower surrounds.',
              },
              {
                question: 'Can Wetwall be used on the floor?',
                answer: 'No, Wetwall is designed for wall applications.',
              },
              {
                question: 'What panel sizes are available?',
                answer: 'Wetwall can manufacture panels up to 60”X96”. 30”,32”,34”,36” X 60”, 72” and 96” panels are the common sizes for wet applications.',
              },
              {
                question: 'How thick is a Wetwall panel?',
                answer: '11mm or approx. 0.43 in',
              },
              {
                question: 'How much does a Wetwall panel weigh?',
                answer: 'Our lightweight patented panels are approx. 1.65 lb/sq.ft. A standard 32X60X72 4-panel kit will weigh approximate­ly 105 lbs.',
              },
              {
                question: 'How long does it take to install Wetwall?',
                answer: 'An average of 2.5 hours for a tub/shower surround.',
              },
      ],
      kits: [
        {
          id:0,
          name: '36" x 34" x 72"',
          sku: '36x34x72',
          group: 'pro',
          thumb: require("../assets/img/kits/36x34x72-Kit.png"),
          images: [
            require("../assets/img/kits/36x34x72-Kit.png"),
          ]
        },
        {
          id:1,
          name: '36" x 34" x 96"',
          sku: '36x34x96',
          group: 'pro',
          thumb: require("../assets/img/kits/36x34x96-Kit.png"),
          images: [
            require("../assets/img/kits/36x34x96-Kit.png"),
          ]
        },
        {
          id:2,
          name: '48" x 34" x 72"',
          sku: '48x34x72',
          group: 'pro',
          thumb: require("../assets/img/kits/48x34x72-Kit.png"),
          images: [
            require("../assets/img/kits/48x34x72-Kit.png"),
          ]
        },
        {
          id:3,
          name: '48" x 34" x 96"',
          sku: '48x34x96',
          group: 'pro',
          thumb: require("../assets/img/kits/48x34x96-Kit.png"),
          images: [
            require("../assets/img/kits/48x34x96-Kit.png"),
          ]
        },
        {
          id:4,
          name: '60" x 30" x 72"',
          sku: '60x30x72',
          group: 'pro',
          thumb: require("../assets/img/kits/60x30x72-Kit.png"),
          images: [
            require("../assets/img/kits/60x30x72-Kit.png"),
          ]
        },
        {
          id:5,
          name: '60" x 30" x 96"',
          sku: '60x30x96',
          group: 'pro',
          thumb: require("../assets/img/kits/60x30x96-Kit.png"),
          images: [
            require("../assets/img/kits/60x30x96-Kit.png"),
          ]
        },
        {
          id:6,
          name: '60" x 32" x 60"',
          sku: '60x32x60',
          group: 'pro',
          thumb: require("../assets/img/kits/60x32x60-Kit.png"),
          images: [
            require("../assets/img/kits/60x32x60-Kit.png"),
          ]
        },
        {
          id:7,
          name: '60" x 32" x 72"',
          sku: '60x32x72',
          group: 'pro',
          thumb: require("../assets/img/kits/60x32x72-Kit.png"),
          images: [
            require("../assets/img/kits/60x32x72-Kit.png"),
          ]
        },
        {
          id:8,
          name: '60" x 32" x 80"',
          sku: '60x32x80',
          group: 'pro',
          thumb: require("../assets/img/kits/60x32x80-Kit.png"),
          images: [
            require("../assets/img/kits/60x32x80-Kit.png"),
          ]
        },
        {
          id:9,
          name: '60" x 32" x 96"',
          sku: '60x32x96',
          group: 'pro',
          thumb: require("../assets/img/kits/60x32x96-Kit.png"),
          images: [
            require("../assets/img/kits/60x32x96-Kit.png"),
          ]
        }
      ],
      mapStyles: {
        styles: [
                    {
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#f5f5f5"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.icon",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#616161"
                        }
                      ]
                    },
                    {
                      "elementType": "labels.text.stroke",
                      "stylers": [
                        {
                          "color": "#f5f5f5"
                        }
                      ]
                    },
                    {
                      "featureType": "administrative.land_parcel",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#bdbdbd"
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#eeeeee"
                        }
                      ]
                    },
                    {
                      "featureType": "poi",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#757575"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#e5e5e5"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#9e9e9e"
                        }
                      ]
                    },
                    {
                      "featureType": "road",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#ffffff"
                        }
                      ]
                    },
                    {
                      "featureType": "road.arterial",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#757575"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#dadada"
                        }
                      ]
                    },
                    {
                      "featureType": "road.highway",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#616161"
                        }
                      ]
                    },
                    {
                      "featureType": "road.local",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#9e9e9e"
                        }
                      ]
                    },
                    {
                      "featureType": "transit.line",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#e5e5e5"
                        }
                      ]
                    },
                    {
                      "featureType": "transit.station",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#eeeeee"
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "geometry",
                      "stylers": [
                        {
                          "color": "#c9c9c9"
                        }
                      ]
                    },
                    {
                      "featureType": "water",
                      "elementType": "labels.text.fill",
                      "stylers": [
                        {
                          "color": "#9e9e9e"
                        }
                      ]
                    }
      ]},

      markers: [
                  {
                    "id": 0,
                    "distance": 0,
                    "name": "Wilsonart Americas",
                    "country": "United States",
                    "address1": "2501 Wilsonart Drive",
                    "address2": "",
                    "city": "Temple",
                    "state": "TX",
                    "zip": 76504,
                    "phone1": "800-433-3222",
                    "phone2": "254-207-7000",
                    "fax": "254-207-3209",
                    "lat": 31.14533,
                    "lng": -97.35225,
                    //"position": new window.google.maps.LatLng(31.14533, -97.35225),
                  },
                  {
                    "id": 1,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "5333 S. Kyrene Road",
                    "address2": "Suite 103",
                    "city": "Tempe",
                    "state": "AZ",
                    "zip": 85283,
                    "phone1": "800-764-6366",
                    "phone2": "480-921-9906",
                    "fax": "480-921-0268",
                    "lat": 33.37408,
                    "lng": -111.94425,
                    //"position": new window.google.maps.LatLng(33.37408, -111.94425),
                  },
                  {
                    "id": 2,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "13911 East Gannet Street",
                    "address2": "P.O. Box 2336",
                    "city": "Santa Fe Springs",
                    "state": "CA",
                    "zip": "90670-5326",
                    "phone1": "562-921-7426",
                    "phone2": "",
                    "fax": "254-207-8822",
                    "lat": 33.89625,
                    "lng": -118.03385,
                    //"position": new window.google.maps.LatLng(33.89625, -118.03385),
                  },
                  {
                    "id": 3,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "6740 Broadway Ave.",
                    "address2": "Unit A",
                    "city": "Jacksonville",
                    "state": "FL",
                    "zip": 32254,
                    "phone1": "800-432-6057",
                    "phone2": "",
                    "fax": "904-695-0796",
                    "lat": 30.33123,
                    "lng": -81.75765,
                    //"position": new window.google.maps.LatLng(30.33123, -81.75765),
                  },
                  {
                    "id": 4,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "1331 N.W. 82nd Ave.",
                    "address2": "",
                    "city": "Miami",
                    "state": "FL",
                    "zip": 33126,
                    "phone1": "800-432-6057",
                    "phone2": "",
                    "fax": "305-477-2545",
                    "lat": 25.78541,
                    "lng": -80.32811,
                    //"position": new window.google.maps.LatLng(25.78541, -80.32811),
                  },
                  {
                    "id": 5,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "7414 Kingspointe Parkway",
                    "address2": "Suite 800",
                    "city": "Orlando",
                    "state": "FL",
                    "zip": "32819-8576",
                    "phone1": "800-432-6057",
                    "phone2": "",
                    "fax": "407-363-7122",
                    "lat": 28.460276,
                    "lng": -81.440721,
                    //"position": new window.google.maps.LatLng(28.460276, -81.440721),
                  },
                  {
                    "id": 6,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "8818 E. Adamo Drive",
                    "address2": "",
                    "city": "Tampa",
                    "state": "FL",
                    "zip": 33619,
                    "phone1": "800-432-6057",
                    "phone2": "",
                    "fax": "813-247-1247",
                    "lat": 27.9495708,
                    "lng": -82.3573919,
                    //"position": new window.google.maps.LatLng(27.9495708, -82.3573919),
                  },
                  {
                    "id": 7,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "2323 Park Central Blvd.",
                    "address2": "",
                    "city": "Decatur",
                    "state": "GA",
                    "zip": 30035,
                    "phone1": "770-593-2424",
                    "phone2": "",
                    "fax": "770-593-0545",
                    "lat": 33.7198621,
                    "lng": -84.1740111,
                    //"position": new window.google.maps.LatLng(33.7198621, -84.1740111),
                  },
                  {
                    "id": 8,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "29 Concord Street",
                    "address2": "",
                    "city": "North Reading",
                    "state": "MA",
                    "zip": "01864",
                    "phone1": "978-664-5230",
                    "phone2": "",
                    "fax": "978-664-4514",
                    "lat": 42.5632144,
                    "lng": -71.125026,
                    //"position": new window.google.maps.LatLng(42.5632144, -71.125026),
                  },
                  {
                    "id": 9,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "50768 Varsity Court",
                    "address2": "",
                    "city": "Wixom",
                    "state": "MI",
                    "zip": 48393,
                    "phone1": "248-960-3388",
                    "phone2": "",
                    "fax": "248-960-9922",
                    "lat": 42.5162404,
                    "lng": -83.5524869,
                    //"position": new window.google.maps.LatLng(42.5162404, -83.5524869),
                  },
                  {
                    "id": 10,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "9201 Wyoming Avenue North",
                    "address2": "Suite 100",
                    "city": "Brooklyn Park",
                    "state": "MN",
                    "zip": 55445,
                    "phone1": "877-424-4358",
                    "phone2": "763-424-1151",
                    "fax": "763-424-4383",
                    "lat": 45.1218708,
                    "lng": -93.3825321,
                    //"position": new window.google.maps.LatLng(45.1218708, -93.3825321),
                  },
                  {
                    "id": 11,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "98 County Road 122",
                    "address2": "",
                    "city": "Oxford",
                    "state": "MS",
                    "zip": 38655,
                    "phone1": "662-513-0293",
                    "phone2": "",
                    "fax": "662-513-0300",
                    "lat": 34.428315,
                    "lng": -89.5235147,
                    //"position": new window.google.maps.LatLng(34.428315, -89.5235147),
                  },
                  {
                    "id": 12,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "11 Twosome Drive",
                    "address2": "",
                    "city": "Moorestown",
                    "state": "NJ",
                    "zip": "08057",
                    "phone1": "800-822-7613",
                    "phone2": "",
                    "fax": "856-866-1812",
                    "lat": 39.9779769,
                    "lng": -74.9751241,
                    //"position": new window.google.maps.LatLng(39.9779769, -74.9751241),
                  },
                  {
                    "id": 13,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "999 South Oyster Bay Road",
                    "address2": "Suite 305",
                    "city": "Bethpage (Hicksville)",
                    "state": "NY",
                    "zip": 11714,
                    "phone1": "866-455-8297",
                    "phone2": "516-935-6980",
                    "fax": "516-935-6875",
                    "lat": 40.7561821,
                    "lng": -73.4980258,
                    //"position": new window.google.maps.LatLng(40.7561821, -73.4980258),
                  },
                  {
                    "id": 14,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "2500 International Street",
                    "address2": "",
                    "city": "Columbus",
                    "state": "OH",
                    "zip": 43228,
                    "phone1": "614-876-1515",
                    "phone2": "",
                    "fax": "614-876-0835",
                    "lat": 40.0038247,
                    "lng": -83.1303033,
                    //"position": new window.google.maps.LatLng(40.0038247, -83.1303033),
                  },
                  {
                    "id": 15,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "1641 Lebanon Pike Circle",
                    "address2": "",
                    "city": "Nashville",
                    "state": "TN",
                    "zip": 37210,
                    "phone1": "615-292-2188",
                    "phone2": "",
                    "fax": "615-292-7849",
                    "lat": 36.151997,
                    "lng": -86.715474,
                    //"position": new window.google.maps.LatLng(36.151997, -86.715474),
                  },
                  {
                    "id": 16,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "4051 La Reunion Parkway",
                    "address2": "Suite 140",
                    "city": "Dallas",
                    "state": "TX",
                    "zip": 75212,
                    "phone1": "214-634-2310",
                    "phone2": "",
                    "fax": "214-634-1435",
                    "lat": 32.7721,
                    "lng": -96.8929122,
                    //"position": new window.google.maps.LatLng(32.7721, -96.8929122),
                  },
                  {
                    "id": 17,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "552 Garden Oaks",
                    "address2": "",
                    "city": "Houston",
                    "state": "TX",
                    "zip": 77018,
                    "phone1": "713-576-5500",
                    "phone2": "",
                    "fax": "713-576-5515",
                    "lat": 29.825113,
                    "lng": -95.408558,
                    //"position": new window.google.maps.LatLng(29.825113, -95.408558),
                  },
                  {
                    "id": 18,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "17745 Lookout Rd",
                    "address2": "Bldg 2, Suite 230",
                    "city": "Schertz",
                    "state": "TX",
                    "zip": 78154,
                    "phone1": "844-297-5591",
                    "phone2": "210-564-1500",
                    "fax": "210-564-1510",
                    "lat": 29.6048966,
                    "lng": -98.2948544,
                    //"position": new window.google.maps.LatLng(29.6048966, -98.2948544),
                  },
                  {
                    "id": 19,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "United States",
                    "address1": "400 Boundary Blvd.",
                    "address2": "",
                    "city": "Algona",
                    "state": "WA",
                    "zip": 98001,
                    "phone1": "855-305-1854",
                    "phone2": "",
                    "fax": "855-305-1855",
                    "lat": 47.2926319,
                    "lng": -122.2493413,
                    //"position": new window.google.maps.LatLng(47.2926319, -122.2493413),
                  },
                  {
                    "id": 20,
                    "distance": 0,
                    "name": "Wilsonart",
                    "country": "Canada",
                    "address1": "6255 Cantay Road",
                    "address2": "Units 2 & 3",
                    "city": "Mississauga",
                    "state": "ON",
                    "zip": "L5R 3Z4",
                    "phone1": "905-565-1255",
                    "phone2": "",
                    "fax": "905-565-1280",
                    "lat": 43.622686,
                    "lng": -79.69528566,
                    //"position": new window.google.maps.LatLng(43.622686, -79.69528566),
                  }
                ]
    }
  },

  mounted () {
    // this.$refs.mapRef.$mapPromise.then((map) => {
    //   console.log(map);
    //   for( var i=0; i<this.markers.length; i++){
    //     this.markers[i].position = new window.google.maps.LatLng(this.markers[i].lat, this.markers[i].lng);
    //   }
    //   this.$forceUpdate();
    // })

    this.player.mute();
    this.player.playVideo();
  },

  computed : {

    player() {
      return this.$refs.youtube.player
    },

    google: gmapApi,

    sorted_markers() {

      let tempMarkers = [];
      for( var i=0; i<this.markers.length; i++){
          let tempMarker = this.markers[i];
          tempMarkers.push(tempMarker);

          if (this.shortList && i == 3) break;
      }
      return tempMarkers.sort((a, b) => { return a.distance - b.distance;});

    },

    currentItem() {
      return this.kits[this.currentItemNumber];
    },
  },

  methods: {

    //33.0126814
    //-96.8887202
    toggleInfoWindow: function(marker, idx) {
      var content = '';
      var addressString = '';
      var addressURL = 'https://www.google.com/maps/search/?api=1&query=';

      this.infoWindowPos = marker.position;

      content = marker.name
        + '<br />';

      addressString += marker.address1;
      addressURL += encodeURI(marker.address1) + '+';

      if (marker.address2 !== '') {
        addressString += '<br />' + marker.address2;
        addressURL += encodeURI(marker.address2) + '+';
      }

      addressString +='<br />' + marker.city + ', ' + marker.state + ' ' + marker.zip + '<br />';
      addressURL += encodeURI(marker.city) + '+' + encodeURI(marker.state) + '+' + encodeURI(marker.zip) + '+';

      content += '<a href="' + addressURL + '" target="_blank">' + addressString + '</a>';

      if (marker.phone1 !== '') {
        content += '<br /><a href="tel:' + marker.phone1 + '">' + marker.phone1 + '</a>';
      }

      if (marker.phone2 !== '') {
        content += '<br /><a href="tel:' + marker.phone2 + '">' + marker.phone2 + '</a>';
      }

      this.infoOptions.content = content;

      //check if its the same marker that was selected if yes toggle
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;

      }
    },

    getThings(lat, lng) {
      //alert(this.getLatLngByZipcode(75007));

      //var location = new window.google.maps.LatLng(33.0126814, -96.8887202);
      var location = new window.google.maps.LatLng(lat, lng);

      for (var j = 0; j < this.markers.length; j++){
        this.markers[j].distance = this.distance(location.lat(), location.lng(), this.markers[j].lat, this.markers[j].lng, 'M');
      }
    },

    distance(lat1, lon1, lat2, lon2, unit) {
      if ((lat1 == lat2) && (lon1 == lon2)) {
        return 0;
      }
      else {
        var radlat1 = Math.PI * lat1/180;
        var radlat2 = Math.PI * lat2/180;
        var theta = lon1-lon2;
        var radtheta = Math.PI * theta/180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
          dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180/Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit=="K") { dist = dist * 1.609344 }
        if (unit=="N") { dist = dist * 0.8684 }
        return dist;
      }
    },

    getLatLngByZipcode(zipcode) {
        var geocoder = new window.google.maps.Geocoder();
        var address = zipcode;
        var latitude;
        var longitude;
        var vm = this;
        geocoder.geocode({ 'address': 'zipcode '+address }, function (results, status) {
            if (status == window.google.maps.GeocoderStatus.OK) {
                var latitude = results[0].geometry.location.lat();
                var longitude = results[0].geometry.location.lng();

                vm.getThings(latitude, longitude);
                alert("Latitude: " + latitude + "\nLongitude: " + longitude);
            } else {
                alert("Request failed.")
            }
        });
        return [latitude, longitude];
    },

    setCurrentItem(itemNumber) {
      this.currentItemNumber = itemNumber;
      this.$bvModal.show('modal-sku');
    },

    zipCodeLookup: function () {

      var newZip = this.zipCode;

      if(newZip.length > 4) {
        this.getLatLngByZipcode(newZip);
      } else {
        alert('Please enter a valid Zip/Postal code.');
      }
    }
  },

  watch: {
    // whenever question changes, this function will run
    zipCode: function (newZip) {

      if(newZip.length > 4) {
        this.getLatLngByZipcode(newZip);
      }
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.locations {
  overflow: scroll;
  height: 300px;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.view-more {
  color: black;
  font-family: 'Montserrat', sans-serif;
  font-size: .8rem;
  text-transform: uppercase;
}

.specs {
    font-family: 'Montserrat', sans-serif;
}
</style>
